/* MŌRA — product page behaviour. Idempotent; re-runs on section reload. */
(function () {

  function gallery(root) {
    var g = root.querySelector('[data-mo-gallery]');
    if (!g || g.dataset.moReady) return;
    g.dataset.moReady = '1';

    var stack  = g.querySelector('[data-mo-gallery-stack]');
    var imgs   = [].slice.call(stack.querySelectorAll('img'));
    var thumbs = [].slice.call(g.querySelectorAll('[data-mo-gallery-thumbs] button'));
    var dots   = [].slice.call(g.querySelectorAll('[data-mo-gallery-dots] button'));
    if (!imgs.length) return;

    function isMobile() { return window.matchMedia('(max-width: 900px)').matches; }

    function mark(i) {
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }

    function goTo(i) {
      var img = imgs[i];
      if (!img) return;
      if (isMobile()) {
        stack.scrollTo({ left: img.offsetLeft - stack.offsetLeft, behavior: 'smooth' });
      } else {
        img.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      mark(i);
    }

    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () { goTo(i); });
    });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });

    // Desktop: highlight the thumb for whichever image is in view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (isMobile()) return;
        entries.forEach(function (e) {
          if (e.isIntersecting) mark(imgs.indexOf(e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      imgs.forEach(function (im) { io.observe(im); });
    }

    // Mobile: dots follow the swipe position
    var ticking = false;
    stack.addEventListener('scroll', function () {
      if (!isMobile() || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(stack.scrollLeft / stack.clientWidth);
        mark(Math.max(0, Math.min(imgs.length - 1, i)));
        ticking = false;
      });
    }, { passive: true });

    // Variant picker asks the gallery to jump to a specific image
    g.moSelectByMediaId = function (id) {
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].dataset.mediaId === String(id)) { goTo(i); return; }
      }
    };

    mark(0);
  }

  function variants(root) {
    var form = root.querySelector('[data-mo-form]');
    if (!form || form.dataset.moReady) return;
    form.dataset.moReady = '1';

    var node = root.querySelector('[data-mo-variants]');
    if (!node) return;
    var data;
    try { data = JSON.parse(node.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-mo-variant-id]');
    var atc     = form.querySelector('[data-mo-atc]');
    var priceEl = root.querySelector('[data-mo-price]');
    var compEl  = root.querySelector('[data-mo-compare]');
    var stockEl = root.querySelector('[data-mo-stock]');
    var stockWrap = root.querySelector('[data-mo-stock-wrap]');
    var gal     = root.querySelector('[data-mo-gallery]');
    var groups  = [].slice.call(root.querySelectorAll('[data-mo-option]'));

    function selected() {
      return groups.map(function (g) {
        var on = g.querySelector('[aria-pressed="true"]');
        return on ? on.dataset.value : null;
      });
    }

    function match(vals) {
      return data.filter(function (v) {
        return vals.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }

    function apply() {
      var v = match(selected());

      groups.forEach(function (g) {
        var label = g.querySelector('[data-mo-option-value]');
        var on = g.querySelector('[aria-pressed="true"]');
        if (label && on) label.textContent = on.dataset.value;
        [].slice.call(g.querySelectorAll('[data-value]')).forEach(function (b) {
          var probe = selected();
          probe[Number(g.dataset.moOptionIndex)] = b.dataset.value;
          var cand = match(probe);
          b.dataset.soldout = cand && cand.available ? 'false' : 'true';
        });
      });

      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compEl) {
        compEl.textContent = v.hasCompare ? v.compare : '';
        compEl.hidden = !v.hasCompare;
      }
      if (stockEl) {
        stockEl.innerHTML = v.available ? stockEl.dataset.in : stockEl.dataset.out;
        if (stockWrap) stockWrap.classList.toggle('mo-stock--out', !v.available);
      }
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? atc.dataset.add : atc.dataset.soldout;
      }
      if (v.mediaId && gal && gal.moSelectByMediaId) gal.moSelectByMediaId(v.mediaId);
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    groups.forEach(function (g) {
      [].slice.call(g.querySelectorAll('[data-value]')).forEach(function (b) {
        b.addEventListener('click', function () {
          [].slice.call(g.querySelectorAll('[data-value]')).forEach(function (o) {
            o.setAttribute('aria-pressed', 'false');
          });
          b.setAttribute('aria-pressed', 'true');
          apply();
        });
      });
    });

    apply();
  }

  function copyCode(root) {
    var b = root.querySelector('[data-mo-copy]');
    if (!b || b.dataset.moReady) return;
    b.dataset.moReady = '1';
    var target = root.querySelector('[data-mo-code]');
    b.addEventListener('click', function () {
      navigator.clipboard.writeText(target.textContent.trim()).then(function () {
        var old = b.dataset.label;
        b.textContent = b.dataset.copied;
        setTimeout(function () { b.textContent = old; }, 2000);
      });
    });
  }

  function boot(root) {
    root = root || document;
    gallery(root); variants(root); copyCode(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();